import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";

import { Toaster } from "sonner";

import "@/App.css";

import {
    LangProvider,
} from "@/contexts/LangContext";

import {
    AuthProvider,
} from "@/contexts/AuthContext";

import {
    CartProvider,
} from "@/contexts/CartContext";

import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import BecomeSeller from "@/pages/BecomeSeller";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import StorePage from "@/pages/StorePage";
import Stores from "@/pages/Stores";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";
import Orders from "@/pages/Orders";
import Invoice from "@/pages/Invoice";
import Favorites from "@/pages/Favorites";
import Chat from "@/pages/Chat";
import Reels from "@/pages/Reels";

import SellerDashboard from "@/pages/seller/Dashboard";
import StoreSetup from "@/pages/seller/StoreSetup";
import SellerProducts from "@/pages/seller/Products";
import ProductForm from "@/pages/seller/ProductForm";
import SellerOrders from "@/pages/seller/Orders";
import Verification from "@/pages/seller/Verification";
import SellerReels from "@/pages/seller/Reels";

import AdminDashboard from "@/pages/admin/Dashboard";
import AdminVerifications from "@/pages/admin/Verifications";
import AdminPayouts from "@/pages/admin/Payouts";
import AdminOrders from "@/pages/admin/Orders";


function AppRouter() {
    return (
        <Routes>

            <Route
                path="/"
                element={<Home />}
            />

            <Route
                path="/login"
                element={<Login />}
            />

            <Route
                path="/register"
                element={<Register />}
            />

            <Route
                path="/sell"
                element={<BecomeSeller />}
            />

            <Route
                path="/products"
                element={<Products />}
            />

            <Route
                path="/products/:product_id"
                element={<ProductDetail />}
            />

            <Route
                path="/stores"
                element={<Stores />}
            />

            <Route
                path="/store/:slug"
                element={<StorePage />}
            />

            <Route
                path="/cart"
                element={<Cart />}
            />

            <Route
                path="/checkout"
                element={
                    <ProtectedRoute>
                        <Checkout />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/payment/:orderId"
                element={
                    <ProtectedRoute>
                        <Payment />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/orders"
                element={
                    <ProtectedRoute>
                        <Orders />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/orders/:orderId/invoices/:sellerId"
                element={
                    <ProtectedRoute>
                        <Invoice />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/favorites"
                element={
                    <ProtectedRoute>
                        <Favorites />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/chat"
                element={
                    <ProtectedRoute>
                        <Chat />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/reels"
                element={<Reels />}
            />


            <Route
                path="/seller"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <SellerDashboard />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/seller/store"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <StoreSetup />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/seller/products"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <SellerProducts />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/seller/products/:id"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <ProductForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/seller/orders"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <SellerOrders />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/seller/verification"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <Verification />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/seller/reels"
                element={
                    <ProtectedRoute
                        roles={["seller"]}
                    >
                        <SellerReels />
                    </ProtectedRoute>
                }
            />


            <Route
                path="/admin"
                element={
                    <ProtectedRoute
                        roles={["admin"]}
                    >
                        <AdminDashboard />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/admin/orders"
                element={
                    <ProtectedRoute
                        roles={["admin"]}
                    >
                        <AdminOrders />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/admin/payouts"
                element={
                    <ProtectedRoute
                        roles={["admin"]}
                    >
                        <AdminPayouts />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/admin/verifications"
                element={
                    <ProtectedRoute
                        roles={["admin"]}
                    >
                        <AdminVerifications />
                    </ProtectedRoute>
                }
            />

        </Routes>
    );
}


function App() {
    return (
        <div className="App">

            <BrowserRouter>

                <LangProvider>

                    <AuthProvider>

                        <CartProvider>

                            <AppRouter />

                            <Toaster
                                position="top-center"
                                richColors
                            />

                        </CartProvider>

                    </AuthProvider>

                </LangProvider>

            </BrowserRouter>

        </div>
    );
}


export default App;